import React from 'react';

interface PromoFooterBannerProps {
  onLearnMore: () => void;
  onStartForFree: () => void;
}

const PromoFooterBanner: React.FC<PromoFooterBannerProps> = ({ onLearnMore, onStartForFree }) => {
  return (
    <div
      className="fixed bottom-0 left-0 w-full z-50"
      style={{
        background: 'linear-gradient(to bottom, #0B2344, #07162B)',
        height: '120px',
      }}
    >
      <div
        className="mx-auto flex items-center justify-center h-full"
        style={{
          maxWidth: '1450px',
          padding: '0 32px',
          gap: '48px',
        }}
      >
        {/* Content */}
        <div className="flex-shrink-0">
          <div className="relative">
            {/* Subtle radial glow behind headline */}
            <div
              className="absolute top-1/2 left-0 transform -translate-y-1/2 pointer-events-none"
              style={{
                width: '400px',
                height: '60px',
                background: 'radial-gradient(ellipse at center, rgba(59, 130, 246, 0.15) 0%, transparent 70%)',
                filter: 'blur(20px)',
              }}
            />

            {/* Headline */}
            <h2
              className="relative font-bold tracking-wide mb-2"
              style={{
                fontSize: '20px',
                background: 'linear-gradient(135deg, #3B82F6 0%, #06B6D4 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              PLAY. SCORE. STREAM. SHARE.
            </h2>

            {/* Body text */}
            <p
              className="relative"
              style={{
                color: '#E5E7EB',
                maxWidth: '650px',
                fontSize: '15px',
              }}
            >
              From social matches to national championships-score and live-stream directly to YouTube with score overlays. No laptops. No complicated setup.
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            onClick={onLearnMore}
            className="px-6 py-2.5 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-[#0B2344]"
            style={{
              background: 'transparent',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              color: '#FFFFFF',
              minHeight: '44px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.6)';
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
              e.currentTarget.style.background = 'transparent';
            }}
          >
            Learn More
          </button>

          <button
            onClick={onStartForFree}
            className="px-6 py-2.5 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-[#0B2344]"
            style={{
              background: '#3B82F6',
              color: '#FFFFFF',
              border: 'none',
              minHeight: '44px',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#2563EB';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#3B82F6';
            }}
          >
            Start for Free
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoFooterBanner;
